/**
 * Operations Performance Dashboard API (internal scorecard).
 *
 * JWT endpoints → shared `secureApi` instance (per CLAUDE.md dual-axios rule). Read-only.
 */
import { secureApi } from './secureApi';

const BASE = '/api/ops/dashboard';

export const operationsDashboardApi = {
  // Response-time (Phase 2 v1) — % of guest messages answered within target (1h) + still-pending (rolling 7d)
  getMessageResponse: () => secureApi.get(`${BASE}/message-response`).then((r) => r.data),

  // Message-feed health (Guest Comms Inc 2) — is the OTA webhook feed alive? Local read; the bounded
  // live Channex reconciliation runs on the daily cron, so refreshing this card costs no API budget.
  getMessageFeedHealth: () => secureApi.get(`${BASE}/message-feed-health`).then((r) => r.data),

  // The two monthly KPIs — guest rating and occupancy, last month and this month so far
  getMonthlyKpis: () => secureApi.get(`${BASE}/monthly-kpis`).then((r) => r.data),

  // Supporting review figures — low ratings in the last 7 days, share of settled checkouts reviewed
  getReviews: (endDate) =>
    secureApi.get(`${BASE}/reviews`, { params: endDate ? { endDate } : {} }).then((r) => r.data),
};

export default operationsDashboardApi;
